<template>
<section>
    <div class="wrap">
        <div class="find_showroom_info">
            <dl class="showroom_info">
                <dt>
                    {{ shopItem.name }}
                    <div><img :src="`${$store.state.dir}images/Group.png`"></div>
                </dt>
                <dd>
                    <span>{{ (shopItem.dealer) ? shopItem.dealer.name : '' }}</span>
                    <p>{{ shopItem.addr }}</p>
                </dd>
            </dl>
        </div>

        <div class="find_consultant_info">
            <ReviewList
                filterChk
                v-model="score"
                :items="reviewItems" 
                :totalCount="totalCount"
            />
        </div>
    </div>
    
</section>
</template>

<script>
import { mapState } from 'vuex';
import ReviewList from '../../components/review/ReviewList.vue';
import { InfinityScrollMixin } from '../../mixins/InfinityScrollMixin';

export default {
    name:'ShopReview',
    mixins: [ InfinityScrollMixin ],
    components:{
        ReviewList
    },
    data() {
        return {
            score: '',
        }
    },
    computed: {
        ...mapState({
            brandItems: state => state.brand.items,
            shopItem: state => state.shop.item,
        }),
        shopId() {
            return this.$route.params.shopId;
        }
    },
    
    watch: {
        score() {
            this.$store.commit('CLEAR_REVIEW_LIST');
            this.changeSearchOption();
        }
    },

    created() {
        this.$store.dispatch('GET_SHOP', this.shopId)
        .then(() => {
            this.setScroll();
            this.getContentList();
            this.$store.commit('SHOW_ONLOAD');
        });
    },

    destroyed() {
        this.removeScroll();
    },

    methods: {
        getContentList() {

            if(this.reviewItems.length < this.totalCount || this.page == 0) {
                this.$store.dispatch(
                    'GET_REVIEW_LIST_PAGE',
                    {
                        shopId: this.shopId,
                        hasContent: 1,
                        score: this.score,
                        page: this.page++,
                        size: this.limit
                    }
                )
                .then(() => {
                    this.scrollPause = false;
                });
            }
            else {
                this.doneFlag = true;
            }
        },
    }
    
}
</script>

<style scoped>

</style>